export enum TenantIds {
  RADFORD = 'radfordmoneyball',
  MUSTANG = 'mustangmoneyball',
  FRONT_OFFICE_METHOD = 'frontofficemethod'
} 